import { ScrollArea } from '@/components/ui';

import React from 'react';

interface MainContentProps {
  children: React.ReactNode;
}

const MainContent: React.FC<MainContentProps> = ({ children }) => {
  return (
    <div className="app-layout__mainContent">
      <ScrollArea
        scrollbars="vertical"
        className="app-layout__scrollArea"
        style={{ minHeight: 'var(--main-content-height)' }}
      >
        {children}
      </ScrollArea>
    </div>
  );
};

export default MainContent;
